import { RoleType } from '../../../models/Role'
import { type PromoteReason, type PromoteResult, type SeatPurchase } from '../../../store/auth/auth'
import { seatTypeLabels } from '../roleChangeSeatImpact'
import { type BulkInviteResult, type BulkResultRow, buildBulkResult } from './bulkInviteResult'

export const requestedPurchase = (result: BulkInviteResult): SeatPurchase => ({
  general: result.rows.filter((resultRow) => resultRow.status === 'requested' && resultRow.row.seatType === RoleType.SEAT).length,
  sidecar: result.rows.filter((resultRow) => resultRow.status === 'requested' && resultRow.row.seatType === RoleType.SIDECAR).length,
})

const reasonNote = (reason: PromoteReason | undefined, seatType: RoleType | null): string | null => {
  switch (reason) {
    case 'noSeatAvailable':
      return seatType ? `No free ${seatTypeLabels[seatType]} seat is available any more.` : 'No free seat is available any more.'
    case 'seatCheckUnavailable':
    case 'roleCheckUnavailable':
      return 'The seat check is unavailable right now.'
    case 'paymentRequired':
      return 'A payment method is needed before a seat can be bought.'
    case 'emailFailed':
      return 'The invitation email could not be sent. The request is unchanged.'
    case 'roleUnavailable':
      return 'The role on this request is no longer available.'
    case 'notRequested':
    case 'alreadyActive':
      return 'This invitation was already sent.'
    case 'notFound':
      return 'This request no longer exists.'
    default:
      return null
  }
}

export const applyBuyOutcome = (result: BulkInviteResult, promoteResults: PromoteResult[]): BulkInviteResult => {
  const outcomes = new Map(promoteResults.map((promoteResult) => [promoteResult.invitationId, promoteResult]))

  const rows = result.rows.map((resultRow): BulkResultRow => {
    if (resultRow.status !== 'requested' || !resultRow.invitationId) {
      return resultRow
    }
    const outcome = outcomes.get(resultRow.invitationId)
    if (!outcome) {
      return resultRow
    }
    if (outcome.outcome === 'promoted') {
      return { ...resultRow, status: 'invited', errors: [] }
    }
    const note = reasonNote(outcome.reason, resultRow.row.seatType)
    return note ? { ...resultRow, errors: [note] } : resultRow
  })

  return buildBulkResult(rows)
}
